import * as actions from './actions';

const initialState = {
	project: null,
	loading: false,
	error: false,
	errorDetail: null
};

function reduceFetchStart(state) {
	return {
		...state,
		loading: true,
		error: false
	};
}

function reduceFetchSuccess(state, action) {
	return {
		...state,
		project: action.payload,
		loading: false,
		error: false,
		errorDetail: null
	};
}

function reduceFetchError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		loading: false
	};
}

export const project = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.FETCH_PROJECT :
			return reduceFetchStart(state);
		case actions.FETCH_PROJECT_SUCCESS :
			return reduceFetchSuccess(state, action);
		case actions.FETCH_PROJECT_ERROR :
			return reduceFetchError(state, action);
		default:
			return state;
	}
};
